import styled from "styled-components";
import { PropertySearchContainerProps } from "./PropertySearch.types";

const chevronSVG = `
<svg width="12" height="7" viewBox="0 0 12 7" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.4625 0.63416L5.5825 4.51416L1.7025 0.63416C1.51567 0.446908 1.26202 0.341675 0.9975 0.341675C0.732982 0.341675 0.479331 0.446908 0.2925 0.63416C-0.0975 1.02416 -0.0975 1.65416 0.2925 2.04416L4.8825 6.63416C5.2725 7.02416 5.9025 7.02416 6.2925 6.63416L10.8825 2.04416C11.2725 1.65416 11.2725 1.02416 10.8825 0.63416C10.4925 0.25416 9.8525 0.24416 9.4625 0.63416Z" fill="#079D56"/>
</svg>
`;

export const PropertySearchContainer = styled.div<PropertySearchContainerProps>`

font-family: 'Averta Std' !important;

background-color: ${(props: { $backgroundcolor: string }) => props.$backgroundcolor};

.property-search-container {
    display: flex;
    align-items: center;
    padding: 0px 20px;
    flex-direction: column;

        h2 {
            font-weight: 700;
            line-height: 36px;
            color: #434645;
            margin-bottom: 16px;

            @media (min-width: 767px) {
                font-size: 28px;
                line-height: 42px;
                text-align: center;
            }
        }

        p {
            font-size: 16px;
            font-weight: 400;
            line-height: 28px;
            color: #5d615f;
            margin: 8px 0;

            @media (min-width: 767px) {
                font-size: 18px;
                line-height: 30px;
                text-align: center;
            }

            @media (min-width: 1023px) {
                font-size: 20px;
                line-height: 32px;
            }
        }

    .property-search-content {
        width: 100%;

        @media (min-width: 767px) {
            flex-direction: row;
        }

        @media (min-width: 1023px) {
            font-size: 20px;
            line-height: 32px;
            width: 850px;
        }
    }

    .property-search-actions {

        .property-search-form {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 16px;
            margin-top: 24px;
            flex-wrap: wrap;
            justify-content: center;

            .title-search{
                display: none;
                min-width: fit-content;
            }

            @media (min-width: 769px) {
                flex-direction: row;
                flex-wrap: nowrap;

                .title-search{
                    display: block;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 24.5px;
                    letter-spacing: 0%;
                    /* width: 250px; */
                }
            }

            @media (min-width: 1023px) {
                font-size: 20px;
                line-height: 32px;
            }
        }

        .form-group {
            display: flex;
            flex-direction: column;
            width: 100%;
        }

        .form-label {
            font-size: 14px;
            color: #434645;
            margin-bottom: 8px;

            @media (min-width: 767px) {
                font-size: 16px;
            }
        }

        .select-input {
            width: 100%;
            font-size: 16px;
            font-weight: 400;
            line-height: 28px;
            text-align: left;
            color: #999E9C;
            padding: 8px;
            border: 2px solid #D9DDDB;
            border-radius: 8px;
            background-color: #FFFFFF;
            cursor: pointer;
            opacity: 0px;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url('data:image/svg+xml;utf8,${encodeURIComponent(chevronSVG)}');
            background-repeat: no-repeat;
            background-position: right 14px center;
            background-size: 12px;
        }

        .select-input:focus {
            border-color: #079D56;
            outline: none;
        }

        .select-input:disabled {
            background-color: #D9DDDB;
            cursor: not-allowed;
        }

        .select-input select {
            color: #333;
            font-size: 14px;
            padding: 8px;


            @media (min-width: 767px) {
                font-size: 16px;
            }
        }

        .select-input option {
            color: #333;
            font-size: 14px;
            padding: 8px;
        }

        .style-button{
            padding: 0;
        }

        .custom-button {
            @media (min-width: 769px) {
                margin-top: 30px;
                height: 48px !important;
                width: 194px !important;
            }

            @media (min-width: 1023px) {
                margin-top: 40px;
                font-size: 16px;
            }
        }
    }
}
`;
